var React = require('react');

function DownloadBg (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 548V5C0 5 440.561 46.0739 721.25 45C1001.94 43.9261 1440 -0.00012207 1440 -0.00012207V548C1440 548 1001.18 506.5 720 506.5C438.823 506.5 0 548 0 548Z","fill":"var(--black)"}));
}

DownloadBg.defaultProps = {"viewBox":"0 0 1440 548","fill":"none","preserveAspectRatio":"none"};

module.exports = DownloadBg;

DownloadBg.default = DownloadBg;
